import { CHAIN_NAMESPACES, MFA_LEVELS, UX_MODE, WEB3AUTH_NETWORK } from '@web3auth/modal'

const PROMEET_BASE_MAINNET_CHAIN_CONFIG = {
  blockExplorerUrl: 'https://basescan.org',
  chainId: import.meta.env.VITE_ETHEREUM_CHAIN_ID,
  chainNamespace: CHAIN_NAMESPACES.EIP155,
  displayName: 'Base Mainnet',
  isTestNet: false,
  logo: 'https://images.web3auth.io/chains/8453.png',
  rpcTarget: import.meta.env.VITE_ETHEREUM_RPC_TARGET,
  ticker: 'ETH',
  tickerName: 'Ethereum',
  wsTarget: import.meta.env.VITE_ETHEREUM_WS_TARGET,
}

export const AUTH_CONFIG = {
  chainConfig: PROMEET_BASE_MAINNET_CHAIN_CONFIG,
  chains: [PROMEET_BASE_MAINNET_CHAIN_CONFIG],
  clientId: import.meta.env.VITE_WEB3AUTH_CLIENT_ID,
  defaultChainId: PROMEET_BASE_MAINNET_CHAIN_CONFIG.chainId,
  enableLogging: false,
  mfaLevel: MFA_LEVELS.NONE, // TODO: we should allow mfa
  sessionTime: 7 * 24 * 60 * 60,
  ssr: false,
  storageType: 'local',
  uiConfig: {
    // defaultLanguage, logoLight, logoDark, theme: { primary: '#000000' }
    appName: import.meta.env.VITE_APP_NAME,
    appUrl: import.meta.env.VITE_APP_FRONTEND_URL,
    loginMethodsOrder: ['google', 'facebook', 'apple', 'linkedin'],
    uxMode: UX_MODE.REDIRECT,
  },
  web3AuthNetwork: WEB3AUTH_NETWORK.MAINNET, // hardcode to prod env
}

export const AUTH_CREATE_STORE_KEY = 'mustCreateStore'
